import { Link, useSearchParams } from 'react-router-dom';
import { Flex } from '@fastnorth/kraken/components/layout';
import FollowToggle from '../../../follow-toggle/FollowToggle.tsx';
import { useApp } from '../../../../hooks/AppProvider.tsx';
import { type JSX, useMemo } from 'react';
import ParticipantInfo, {
  type ParticipantInfoProps,
} from '../../../../components/participant-info/ParticipantInfo.tsx';
import type { ParticipantSearchRow } from '../../../../types/events.ts';
import { VirtualChallengeType } from '@fastnorth/timer-api';
import RewardLink from '../../../../views/leaderboard/components/RewardLink.tsx';

type ParticipantSummaryDetailProps = {
  participant: ParticipantSearchRow;
  resultsSubEventId: number;
  closeSearch?: () => void;
  includeRaceName?: boolean;
  includeAward?: boolean;
  includeFollow?: boolean;
  followTogglePlacement?: 'left' | 'right';
  displayNameSize?: ParticipantInfoProps['displayNameSize'];
};

const ParticipantSummaryDetail = ({
  participant,
  resultsSubEventId,
  closeSearch = () => {},
  includeRaceName = false,
  includeAward,
  includeFollow = false,
  followTogglePlacement = 'left',
  displayNameSize,
}: ParticipantSummaryDetailProps): JSX.Element | null => {
  const [{ event }] = useApp();
  const [search] = useSearchParams();
  const { id, displayName } = participant;

  // Find the specific sub-event for this result to check its predictive tracking setting
  const shouldShowFollowToggle = useMemo(() => {
    if (includeFollow) {
      return includeFollow;
    }
    if (event) {
      const currentSubEvent = event.subEvents.find(
        (subEvent) => `${subEvent.id}` === `${resultsSubEventId}`
      );
      return (
        currentSubEvent?.challengeSettings?.type === VirtualChallengeType.DISTANCE ||
        currentSubEvent?.settings?.isPredictiveTrackingEnabled ||
        false
      );
    }
    return false;
  }, [event, resultsSubEventId, includeFollow]);

  const followTogglePosition = followTogglePlacement === 'right' ? 'flex-row' : 'flex-row-reverse';
  const hasAdvertising = !!(participant.advertising && participant.advertising !== '#');
  console.log('participant', participant.advertising);

  if (!event) return null;

  return (
    <Flex className={`w-full items-center py-3 ${followTogglePosition}`} gap={'6'}>
      <Flex className={'flex-row w-full justify-between'}>
        <Link
          onClick={closeSearch}
          to={`/events/${event!.uniqueCode}/race/${resultsSubEventId}/participant/${id}?${search}`}
          className={`${hasAdvertising ? '' : 'w-full'}`}>
          <ParticipantInfo
            participant={participant}
            resultsSubEventId={resultsSubEventId}
            includeRaceName={includeRaceName}
            includeAward={includeAward}
            displayNameSize={displayNameSize}
          />
        </Link>
        {hasAdvertising && <RewardLink url={participant.advertising} />}
      </Flex>
      {shouldShowFollowToggle && (
        <FollowToggle
          id={id}
          participantName={displayName || ''}
          hideLabel={true}
          trackingLocation={'participant_summary_details'}
        />
      )}
    </Flex>
  );
};

export default ParticipantSummaryDetail;
